import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Form, InputGroup } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const Search = (props) => {
    const { t } = useTranslation();
    const { value, onChange, id, classN, small } = props;
    return (
        <Form.Group controlId={id} className={classN ? classN : "mb-3"}>
            <Form.Label>{t("search")}</Form.Label>

            <InputGroup controlId={id} className="form-control-search">
                <Form.Control aria-describedby="search-input" value={value} onChange={onChange} placeholder={t("typePhrase")} size={small ? "sm" : "md"} />
                <InputGroup.Text id="search-input">
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                </InputGroup.Text>
            </InputGroup>
        </Form.Group>
    );
};

export default Search;
